'use strict';

var processInclude = require('base/util');
var tagManager = require('int_googletags/tagManager');

$(document).ready(function () {
    processInclude(require('base/product/quickView'));
    processInclude(require('lyonscg/product/wishlistHeart'));
    processInclude(require('productcompare/product/compare'));
    processInclude(require('wishlists/product/wishlistHeart'));
    processInclude(require('org/search/search'));
    tagManager.category();
});

